<agpr-dialog-container
    [id]="'newEntityDialog'"
    [heading]="localizations.header"
    (close)="onCloseClick();"
>
    <div
        class="agpr-newEntityDialog"
        [ngStyle]="{width: width + 'px'}"
    >
        <div class="agpr-newEntityDialog-header">
            <div class="agpr-newEntityDialog-iconAndHeader">
                <div class = "agpr-newEntityDialog-iconAndHeader-icon" ngClass="{{iconClass}}" aria-hidden="true"></div>
                <div>
                    <div class = "agpr-newEntityDialog-iconAndHeader-headerText">{{localizations.description | localize}}</div>
                    <div class = "agpr-newEntityDialog-iconAndHeader-headerEntity">{{localizations.entityName | localize}}</div>
                </div>
            </div>
        </div>
        <div class="agpr-newEntityDialog-block">
            <agpr-button
                type="button"
                [label]="localizations.newItemButton | localize"
                [style]="buttonTypes.primary"
                class="agpr-newEntityDialog-newItemButton"
                id="newEntityDialog.newButton"
                (click)="onCreateClick();"
            >
            </agpr-button>
        <!-- TODO : Add this back using templates for better customization? -->
        <!--div
            *ngIf="userOptions && userOptions.length"
            class="agpr-newEntityDialog-blockActions"
        >
            <button
                *ngFor="let option of userOptions; let i = index;"
                class="agpr-newEntityDialog-action"
                [id]="'newEntityDialog.action_' + i"
                (click)="optionSelected($event, i)"
            >
                <span class="agpr-newEntityDialog-actionIcon">
                    <i [class]="option.icon"></i>
                </span>
                <span class="agpr-newEntityDialog-actionLabel">
                    {{ option.name }}
                </span>
                <span class="agpr-newEntityDialog-actionHint">
                    {{ option.helperText | localize }}
                </span>
            </button>
        </div-->
            <div  class="agpr-newEntityDialog-option">
                <span >{{localizations.or | localize}}</span>
            </div>
            <div  class="agpr-newEntityDialog-existingContentBlock">
                <div class="agpr-newEntityDialog-existingCaption">{{localizations.itemListDescription | localize}}</div>
                <div class="agpr-newEntityDialog-flexContainer">
                    <div class="agpr-newEntityDialog-itemListHeader">
                        {{localizations.itemListHeader | localize}}
                    </div>
                    <div class="agpr-newEntityDialog-filterText">
                        <agpr-text-input
                            [id]="'newEntityDialog.filterTextInput'"
                            [initialFocus]="true"
                            [(ngModel)]="searchString"
                            (ngModelChange)="onFilterTextChange();"
                            [ariaLabel]="localizations.itemListFilterPlaceholder"
                            [placeholder]="localizations.itemListFilterPlaceholder | localize"
                            [bottomMargin]="false"
                        ></agpr-text-input>
                    </div>
                </div>
                <div class="agpr-newEntityDialog-table">
                    <agpr-scroll-panel>
                        <div class="agpr-newEntityDialog-tableContent">
                            <ul
                                id="sourceSelection"
                                *ngIf="filteredItems"
                                class="agpr-newEntityDialog-tableList"
                                agprListKeyboardNavigation
                            >
                                <!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
                                <li
                                    *ngFor="let listItem of filteredItems; index as indexNum"
                                    (keydown)="onRowSelect(listItem, $event)"
                                    (click)="onRowSelect(listItem)"
                                    [ngClass]="{
                                        'agpr-newEntityDialog-activeItem': (selectedItem?.value == listItem.value),
                                        'agpr-newEntityDialog-itemListItem': (selectedItem?.value != listItem.value),
                                        'agpr-newEntityDialog-itemList':(indexNum % 2) != 0,
                                        'agpr-newEntityDialog-itemList--white':(indexNum % 2) == 0
                                    }"
                                    class="agpr-newEntityDialog-itemListLink"
                                    [id]="'newEntityDialog.listItem_' + indexNum"
                                >
                                    <span class="agpr-newEntityDialog-itemNameColumn">
                                        {{ listItem.label }}
                                    </span>
                                    <span class="agpr-newEntityDialog-itemTypeColumn">
                                        {{ listItem.type | localize }}
                                    </span>
                                </li>
                                <!-- eslint-enable @angular-eslint/template/interactive-supports-focus -->
                            </ul>
                            <div *ngIf="isLoading"
                                class="agpr-newEntityDialog-loading"
                                [agprLoading]="true"
                            >
                            </div>
                        </div>
                    </agpr-scroll-panel>
                </div>
            </div>
        </div>
    </div>
    <ng-template #footerLeft>
        <agpr-button
            type="button"
            [label]="localizations.cancel | localize"
            class="ui-button-secondary"
            id="newEntityDialog.cancelButton"
            [style]="buttonTypes.secondary"
            (click)="onCancelClick();"
        >
        </agpr-button>
    </ng-template>
    <ng-template #footerRight>
        <agpr-button *ngIf="this.selectedItem"
            [style]="buttonTypes.primary"
            id="newEntityDialog.useSelectedButton"
            type="button"
            [label]="localizations.clone | localize"
            (click)="onCloneClick();"
        >
        </agpr-button>
    </ng-template>
</agpr-dialog-container>
